export const adminCenterSidebarLinks = [
    {
        title: "Overview",
        route: "overview",
    },
    {
        title: "User Management",
        route: "user-management",
    },
    {
        title: "Requests Management",
        route: "requests-management",
    },
    {
        title: "Billing",
        route: "billing",
    },
    {
        title: "Admin Settings",
        route: "admin-settings",
    },
];
